import { Datatype } from './types';

export const STRING_DATATYPE: Datatype = 'STRING';
export const TIME_DATATYPE: Datatype = 'TIME';
export const PICTURE_DATATYPE: Datatype = 'PICTURE';
export const PHONE_DATATYPE: Datatype = 'PHONE_NUM';
export const UID_DATATYPE: Datatype = 'UID';
export const INT_DATATYPE: Datatype = 'INT';
export const FILE_DATATYPE: Datatype = 'FILE';

// KEEP IN SYNC WITH Datatype IN src/util/interfaces.ts
export const VALID_DATATYPES: Datatype[] = [
  INT_DATATYPE,
  STRING_DATATYPE,
  TIME_DATATYPE,
  PICTURE_DATATYPE,
  PHONE_DATATYPE,
  UID_DATATYPE,
  FILE_DATATYPE,
];
